import React from 'react';
import PropTypes from 'prop-types';
export default function H5({ props, children }) {
    return <h5 {...props}>{children}</h5>;
}

H5.propTypes = {
    children: PropTypes.element,
};
